import { Route, Redirect} from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

export const PrivateRoute = ({component: Component, ...rest }) => {
  
  return (
    <Route
      {...rest}
      render={props => {
        const userToken = secureLocalStorage.getItem("token");
        if(userToken){
          return <Component {...props} />;
        } else {
            if(props.location?.pathname){
                secureLocalStorage.setItem("intended",props.location?.pathname);
            }
          return (
            <Redirect
              to={{
                pathname: "/auth/login",
              }}
            />
          );
        }
      }}
    />
  );
};


export default PrivateRoute;
